import * as React from 'react'

import ClickAwayListener from '@mui/material/ClickAwayListener'
import Grow from '@mui/material/Grow'

import Popper from '@mui/material/Popper'
import styles from './styles.module.css'
import { useSelector } from '../../stores/dashboard.store'

const ProjectsList = ({
    buttonRef,
    open,
    onClose,
    projects,
    onCreateProject,
    onNavigateProject,
    placement="center-top",
    style = {},
}) => {
    const { plan } = useSelector()
    const handleClose = (event) => {
        if (
            buttonRef?.current &&
            buttonRef?.current?.contains(event.target)
        ) {
            return
        }

        onClose()
    }

    const prevOpen = React.useRef(open)
    React.useEffect(() => {
        if (prevOpen?.current === true && open === false) {
            buttonRef?.current?.focus()
        }

        prevOpen.current = open
    }, [open])

    return (
        <Popper
            style={{ ...style }}
            open={open}
            anchorEl={buttonRef?.current}
            role={undefined}
            placement={placement}
            transition
            disablePortal
        >
            {({ TransitionProps, placement }) => (
                <Grow {...TransitionProps} style={{
                    transformOrigin:
                        placement === 'bottom-start' ? 'right bottom' : 'right top'
                }}>
                    <div className={styles.accountMenu}>
                        <ClickAwayListener onClickAway={handleClose}>
                            <div className={styles.accountMenuContainer}>
                                <div className={styles.accountMenuBody}>
                                    {projects.map(x => (
                                        <div style={{borderRadius: 0}} className={styles.accountMenuItem} onClick={() => {onNavigateProject(x); handleClose()} } key={x?.id}>{x?.name}</div>
                                    ))}
                                </div>
                                { projects?.length < plan?.maxProjects && (
                                <div className={styles.accountMenuFooter}>
                                    <div style={{borderRadius: '0px 0px 8px 8px'}} className={styles.accountMenuItem} onClick={onCreateProject}>Create Project</div>
                                </div> )}
                            </div>
                        </ClickAwayListener>
                    </div>
                </Grow>
            )}
        </Popper>
    )
}

export default ProjectsList